/* ── Gallery arrow navigation ── */
function galleryNav(dir) {
  const thumbs = Array.from(document.querySelectorAll('#gallery-thumbs .g-thumb'));
  if (!thumbs.length) return;
  const cur = thumbs.findIndex(t => t.classList.contains('active'));
  const next = Math.max(0, Math.min(thumbs.length - 1, (cur === -1 ? 0 : cur) + dir));
  const thumb = thumbs[next];
  if (!thumb) return;
  const url = thumb.querySelector('img')?.src.replace(/&width=\d+/, '&width=900').replace(/\?width=\d+/, '?width=900') || '';
  selThumb(thumb, url);
  thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  // Update arrow visibility
  document.getElementById('gallery-prev')?.classList.toggle('hidden', next === 0);
  document.getElementById('gallery-next')?.classList.toggle('hidden', next === thumbs.length - 1);
}

// Init arrow states after thumbs are built
function initGalleryArrows() {
  const thumbs = document.querySelectorAll('#gallery-thumbs .g-thumb');
  if (thumbs.length <= 1) {
    document.getElementById('gallery-prev')?.classList.add('hidden');
    document.getElementById('gallery-next')?.classList.add('hidden');
  } else {
    document.getElementById('gallery-prev')?.classList.add('hidden'); // first image — hide prev
  }
}

/* ── REWARDS POINTS ── */
function updateRewardsPoints() {
  price = document.getElementById('product-price-current')?.dataset.price || 0;
  
  console.log("Current price:", price);

  const el = document.getElementById('rewards-points');
  if (!el) return;
  el.textContent = Math.round(price * 2 / 100);
}

/* ── DATA ── */
const COLOURS = [
  { name:'Grey',            hex:'#A8A5A1', bg:'#EDECEB', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_Grey.jpg?v=1740128403' },
  { name:'White',           hex:'#ECEAE5', bg:'#F5F4F2', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_White.jpg?v=1740128403' },
  { name:'Beige',           hex:'#C8B8A0', bg:'#F2EDE5', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_Beige.jpg?v=1740128403' },
  { name:'Dusty Pink',      hex:'#DCA8A8', bg:'#F7EEEE', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_Dusty_Pink.jpg?v=1740128403' },
  { name:'Mauve',           hex:'#B8909C', bg:'#F0E8EC', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie.Mauve.jpg?v=1740128403' },
  { name:'Pistachio Green', hex:'#9CB894', bg:'#EDF3EB', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_Pistashio.jpg?v=1740128403' },
  { name:'Army Green',      hex:'#6B7C5A', bg:'#E8EDE3', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_Army_Green.jpg?v=1740128403' },
  { name:'Sky Blue',        hex:'#88B4D0', bg:'#E8F2F8', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_blue.jpg?v=1740128403' },
  { name:'Agean Teal',      hex:'#4A8C9C', bg:'#E3F0F3', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_Agean_Teal.jpg?v=1740128403' },
  { name:'Navy Blue',       hex:'#2C3E6B', bg:'#E3E8F0', img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Premium_Bamboo_Onesie_Navy.jpg?v=1740127651' },
];

const SIZES = ['0–3M','3–6M','6–12M','12–18M','18–24M'];

// Per-variant OOS: colours that are OUT OF STOCK for each size
// In-stock combos:
//   0–3M:   White only
//   3–6M:   NONE (fully sold out)
//   6–12M:  Mauve only
//   12–18M: Dusty Pink, Mauve
//   18–24M: White, Dusty Pink, Army Green, Sky Blue, Agean Teal
const VARIANT_OOS = {
  '0–3M':   new Set(['Grey','Beige','Dusty Pink','Mauve','Pistachio Green','Army Green','Sky Blue','Agean Teal','Navy Blue']),
  '3–6M':   new Set(['Grey','White','Beige','Dusty Pink','Mauve','Pistachio Green','Army Green','Sky Blue','Agean Teal','Navy Blue']),
  '6–12M':  new Set(['Grey','White','Beige','Dusty Pink','Pistachio Green','Army Green','Sky Blue','Agean Teal','Navy Blue']),
  '12–18M': new Set(['Grey','White','Beige','Pistachio Green','Army Green','Sky Blue','Agean Teal','Navy Blue']),
  '18–24M': new Set(['Grey','Beige','Mauve','Pistachio Green','Navy Blue']),
};

// Helper: is a specific size+colour combo OOS?
function isVariantOOS(size, colourName) {
  return VARIANT_OOS[size]?.has(colourName) ?? false;
}
// Is every colour for this size OOS?
function isSizeFullyOOS(size) {
  return VARIANT_OOS[size]?.size === COLOURS.length;
}
// Is every size for this colour OOS?
function isColourFullyOOS(colourName) {
  return SIZES.every(size => isVariantOOS(size, colourName));
}
// How many colours are in stock for this size?
function sizeInStockCount(size) {
  return COLOURS.length - (VARIANT_OOS[size]?.size ?? 0);
}

const LOW_STOCK = new Set([]); // handled per-variant below

let activeColour  = 0;
let activeSize    = null;
let activeOOS     = false;
let bundleOpen    = false; // bundle nudge state (legacy ref)
let bundleQty     = 1;    // bundle nudge qty (legacy ref)

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', () => {
  updateRewardsPoints();
  // buildSwatches();
  // buildSizes();
  buildThumbs();
  initGalleryArrows();
  // buildStars(4.9);
  buildRecommendations();
  // buildMoreColors() — now handled by custom-product.js
  // initSticky();
  // applyColour();
  // initCTS();

  setPersonaliseCTALink();

});

/* ── STAR BUILDER — renders partial stars to match screenshot ── */
function buildStars(rating) {
  const container = document.getElementById('stars-display');
  if (!container) return;
  const full   = Math.floor(rating);
  const partial = rating - full;
  const empty  = 5 - full - (partial > 0 ? 1 : 0);
  let html = '';
  const gold = '#555';
  const muted = '#ccc';
  // Full stars
  for (let i = 0; i < full; i++) {
    html += `<svg width="16" height="16" viewBox="0 0 24 24" fill="${gold}" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>`;
  }
  // Partial star
  if (partial > 0) {
    const pct = Math.round(partial * 100);
    html += `<svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <defs><linearGradient id="pg"><stop offset="${pct}%" stop-color="${gold}"/><stop offset="${pct}%" stop-color="${muted}"/></linearGradient></defs>
      <path fill="url(#pg)" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>`;
  }
  // Empty stars
  for (let i = 0; i < empty; i++) {
    html += `<svg width="16" height="16" viewBox="0 0 24 24" fill="${muted}" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>`;
  }
  container.innerHTML = html;
}

/* ── COLOUR ── */
function buildSwatches() {
  document.getElementById('swatches').innerHTML = COLOURS.map((c, i) => {
    const fullyOOS = isColourFullyOOS(c.name);
    return `<div class="swatch ${i===0?'active':''} ${fullyOOS?'swatch--oos':''}"
      style="background:${c.hex};" title="${c.name}${fullyOOS?' (Sold Out)':''}"
      onclick="setColour(${i})"></div>`;
  }).join('');
}

function setColour(i) {
  activeColour = i;
  document.querySelectorAll('#swatches .swatch').forEach((el,j) => el.classList.toggle('active', j===i));
  applyColour();
  if (activeSize) updateVariantState(); // re-check OOS for new colour
  if (bundleOpen && bundleQty > 1) renderBundleItems();
  mcSetColour(i); // sync More In section (custom-product.js)
}

function renderBundleItems() { /* stub — bundle nudge colour sync */ }

function applyColour() {
  const c = COLOURS[activeColour];
  document.getElementById('colour-name').textContent = c.name;
  document.getElementById('s-colour').textContent = c.name;
  // Update main gallery image
  const mainImg = document.getElementById('gallery-main-img');
  if (mainImg) { mainImg.src = c.img + '&width=900'; mainImg.alt = 'Premium Bamboo Classic Baby Onesie in ' + c.name; }
  // Update colour thumb
  const ctImg = document.getElementById('colour-thumb-img');
  if (ctImg) ctImg.src = c.img + '&width=200';
  // Sticky bar
  document.getElementById('s-thumb').style.background = c.bg;
  const sti = document.getElementById('s-thumb-img'); if(sti) sti.src = c.img + '&width=120';
  // CTS thumbs
  syncCTSThumbs();
  if (document.getElementById('size-btns').children.length) updateSizeBadges();

  if (document.getElementById('size-btns').children.length) updateSizeBadges();
}

/* ── SIZE — OOS items get a badge above + strikethrough text ── */
function buildSizes() {
  // All sizes get sz-wrap so we can toggle OOS badge dynamically on colour change
  document.getElementById('size-btns').innerHTML = SIZES.map(s => {
    const key = s.replace('–', '-');
    return `<div class="sz-wrap" id="sz-wrap-${key}">
      <span class="oos-badge" id="oos-badge-${key}" style="display:none;">OOS</span>
      <button class="sz" id="sz-btn-${key}" onclick="setSize('${s}', this)">${s}</button>
    </div>`;
  }).join('');
  updateSizeBadges();
}

function updateSizeBadges() {
  const colourName = COLOURS[activeColour].name;
  SIZES.forEach(s => {
    const key = s.replace('–', '-');
    const badge = document.getElementById('oos-badge-' + key);
    const btn   = document.getElementById('sz-btn-' + key);
    if (!badge || !btn) return;
    const oos = isVariantOOS(s, colourName);
    badge.style.display = oos ? 'block' : 'none';
    btn.classList.toggle('oos', oos);
  });
}




function setSize(s, btn) {
  activeSize = s;
  document.querySelectorAll('#size-btns .sz').forEach(el => el.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById('size-name').textContent = s;
  document.getElementById('size-name').style.color = 'var(--ink)';
  document.getElementById('size-error').classList.remove('show');
  document.getElementById('s-size').textContent = `Size: ${s}`;
  updateVariantState();
}

function updateVariantState() {
  if (!activeSize) return;
  const colourName = COLOURS[activeColour].name;
  activeOOS = isVariantOOS(activeSize, colourName);

  const atcBtn    = document.getElementById('atc-btn');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const warning   = document.getElementById('oos-warning');

  if (activeOOS) {
    atcBtn.textContent    = 'Notify Me When Available';
    stickyBtn.textContent = 'Notify Me When Available';
    warning.classList.remove('show');
  } else {
    atcBtn.textContent    = 'Add to cart';
    stickyBtn.textContent = 'Add to cart';
    // Low-stock nudge: ≤2 colours left for this size
    const inStockCount = sizeInStockCount(activeSize);
    if (inStockCount <= 2) {
      document.getElementById('oos-warning-text').textContent =
        'Only a few pieces remaining.';
      warning.classList.add('show');
    } else {
      warning.classList.remove('show');
    }
  }
}

/* ── GALLERY THUMBS ── */
function buildThumbs() {
  const imageElements = document.querySelectorAll('#product-gallery-images-data .gallery-images-data');
  // Videos come through with their preview image as data-image; the type and
  // media id let selThumb() hand them to gallerySyncVideo() (custom-product.js).
  const THUMBS = Array.from(imageElements).map(element => ({
    url: element.dataset.image,
    type: element.dataset.type || 'image',
    id: element.dataset.mediaId || ''
  }));
  document.getElementById('gallery-thumbs').innerHTML = THUMBS.map((m, i) =>
    `<div class="g-thumb ${i===0?'active':''}${m.type!=='image'?' g-thumb--video':''}" data-type="${m.type}" data-media-id="${m.id}" onclick="selThumb(this,'${m.url}')" style="">
      <img src="${m.url}" alt="Product detail" style="width:100%;height:100%;object-fit:cover;border-radius:var(--r);">
    </div>`
  ).join('');
  // First thumb click also sets the colour thumb
  // const colourThumb = `<div class="g-thumb" onclick="selThumb(this,COLOURS[activeColour].img+'&width=900')" id="colour-thumb" style="background:var(--off-white);">
  //   <img id="colour-thumb-img" src="${COLOURS[0].img}&width=200" alt="Colour swatch" style="width:100%;height:100%;object-fit:cover;border-radius:var(--r);">
  // </div>`;
  // document.getElementById('gallery-thumbs').insertAdjacentHTML('afterbegin', colourThumb);

  const mainImg = document.getElementById('gallery-main-img');
  const firstThumb = document.querySelector('.gallery-thumbs .g-thumb');
  // A video thumb keeps its own preview — mainImg is still the featured image.
  if(mainImg && firstThumb && firstThumb.dataset.type === 'image') firstThumb.querySelector('img').src = mainImg.src + '&width=300';
  // Media in admin order: if a video leads, start it (and shows its poster underneath).
  if (firstThumb && firstThumb.dataset.type !== 'image') selThumb(firstThumb, firstThumb.querySelector('img')?.src.replace(/&width=\d+/, '&width=900'));
  else if (typeof gallerySyncVideo === 'function') gallerySyncVideo(firstThumb);
}

function selThumb(el, imgUrl) {
  document.querySelectorAll('.g-thumb').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
  if (imgUrl) {
    const mainImg = document.getElementById('gallery-main-img');
    mainImg.src = imgUrl;
  }
  if (typeof gallerySyncVideo === 'function') gallerySyncVideo(el);
}

/* ── ATC ── */
function handleBundleATC() {
  const btn = document.getElementById('btn-bundle-atc');
  const qty = bundleQty;
  const label = qty === 1 ? '1 onesie' : `${qty} onesies`;
  btn.textContent = `${label} added to cart`;
  btn.classList.add('added');
  setTimeout(() => {
    btn.textContent = 'Add Items to Cart';
    btn.classList.remove('added');
  }, 2400);
}

function handleCTSATC() {
  const btn = document.getElementById('btn-cts-atc');
  // Add the main onesie
  const mainColour = COLOURS[activeColour].name;
  const mainSize = activeSize || '0–3M';
  addToCart('Classic Baby Onesie', mainColour, mainSize, 34.90, (COLOURS.find(c=>c.name===mainColour)||{}).img);
  // Add each checked add-on
  const CTS_NAMES = {
    1: 'Premium Bamboo Bandana Bib',
    2: 'Baby Beanie',
    3: 'Velcro Mittens',
    4: 'Hooded Baby Towel',
    5: 'Premium Bamboo Sleeping Bag',
    6: 'Premium Bamboo Swaddle',
    7: 'Premium Bamboo Baby Leggings'
  };
  const CTS_PRICES_MAP = { 1: 19.90, 2: 29.90, 3: 29.90, 4: 39.90, 5: 59.90, 6: 29.90, 7: 24.90 };
  const CTS_IMGS = {
    1: 'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/230512326597_0070_01_RM_1600x1600_4ac1e3c6-23f4-45ca-b72d-759eb2915dee.jpg?v=1687776837&width=120',
    2: 'https://cdn.shopify.com/s/files/1/0078/0940/0883/products/191125222110_0001_01_CA_2048x2048_74eb4949-09d5-4f09-ba01-589ea3fc42d6.jpg?v=1668360823&width=120',
    3: 'https://cdn.shopify.com/s/files/1/0078/0940/0883/products/191125222110_0012_01_CA_2048x2048_83e1e7ae-beb8-45dc-ac39-cc4bab9272da.jpg?v=1709710292&width=120',
    4: 'https://www.raphandremy.com/cdn/shop/products/Personalised_RAPH_REMY_Hooded_Baby_Towel_1.jpg?v=1679469936&width=120',
    5: 'https://www.raphandremy.com/cdn/shop/files/Sleeping-Bag-Front_Army-Green.webp?v=1773202734&width=120',
    6: 'https://www.raphandremy.com/cdn/shop/products/Personalised_swaddle.jpg?v=1674724522&width=120',
    7: 'https://www.raphandremy.com/cdn/shop/files/RAPH_REMY_Premium_Bamboo_Baby_Leggings_Grey.jpg?v=1740128403&width=120'
  };
  Object.entries(ctsState).forEach(([k, checked]) => {
    if (!checked) return;
    const idx = parseInt(k);
    const colour = COLOURS[ctsItemColours[idx] ?? activeColour].name;
    // Get selected size for this item (fallback to 'One Size')
    const pickerEl = document.getElementById('cts-picker-' + idx);
    const activeSzEl = pickerEl ? pickerEl.querySelector('.cts-sz.active') : null;
    const itemSize = activeSzEl ? activeSzEl.textContent : 'One Size';
    addToCart(CTS_NAMES[idx], colour, itemSize, CTS_PRICES_MAP[idx], CTS_IMGS[idx]);
  });
  const count = Object.values(ctsState).filter(Boolean).length + 1;
  btn.textContent = `${count} item${count > 1 ? 's' : ''} added`;
  btn.classList.add('added');
  setTimeout(() => {
    btn.textContent = 'Add Items to Cart';
    btn.classList.remove('added');
  }, 2000);
}

/* handleATC is defined in the cart script below */

/* ── COMPLETE THE SET ── */
const CTS_PRICES   = { 1: 18.90, 2: 22.90, 3: 19.90 };
let ctsState       = { 1: false, 2: false, 3: false };
let ctsItemColours = { 1: 0, 2: 0, 3: 0 };

function initCTS() {
  [1,2,3,4,5,6,7].forEach(idx => {
    const el = document.getElementById(`cts-colours-${idx}`);
    el.innerHTML = COLOURS.map((c,i) =>
      `<div class="cts-swatch ${i===0?'active':''}" style="background:${c.hex};" title="${c.name}"
            onclick="setCTSColour(${idx},${i},this)"></div>`
    ).join('');
  });
  // sync thumb colours with main colour on init
  syncCTSThumbs();
}

function syncCTSThumbs() {
  // Only the onesie (item 0) changes with colour selection
  const img0 = document.getElementById('cts-img-0');
  if (img0) img0.src = COLOURS[activeColour].img + '&width=120';
}

function toggleCTS(idx) {
  ctsState[idx] = !ctsState[idx];
  const cb  = document.getElementById(`cts-cb-${idx}`);
  const pkl = document.getElementById(`cts-picker-${idx}`);
  cb.classList.toggle('checked', ctsState[idx]);
  pkl.classList.toggle('open',   ctsState[idx]);
  if (ctsState[idx]) {
    // Pre-select current main colour
    ctsItemColours[idx] = activeColour;
    document.querySelectorAll(`#cts-colours-${idx} .cts-swatch`).forEach((el,j) =>
      el.classList.toggle('active', j === activeColour)
    );
    // thumb images are static — onesie handled by syncCTSThumbs
  }
  updateCTSTotal();
}

function setCTSColour(idx, colIdx, el) {
  ctsItemColours[idx] = colIdx;
  el.closest('.cts-colour-row').querySelectorAll('.cts-swatch').forEach((b,j) => b.classList.toggle('active', j===colIdx));
  // thumb images are static product shots
}

function updateCTSTotal() {
  const addOnCount = Object.values(ctsState).filter(Boolean).length;
  const totalCount = 1 + addOnCount;
  const subtotal = 34.90 + Object.entries(ctsState).reduce((s,[k,v]) => s + (v ? ({1:19.90,2:29.90,3:29.90,4:39.90,5:59.90,6:29.90,7:24.90})[+k]||0 : 0), 0);

  let discPct = 0;
  if (totalCount >= 5) discPct = 0.20;
  else if (totalCount >= 3) discPct = 0.15;

  const discAmount = subtotal * discPct;
  const total = subtotal - discAmount;

  const saveEl  = document.getElementById('cts-save-label');
  const saveBar = document.getElementById('cts-save-bar');
  const totalEl = document.getElementById('cts-total');
  const origEl  = document.getElementById('cts-total-orig');
  const priceEl = document.getElementById('cts-total-price');

  totalEl.classList.toggle('show', addOnCount > 0);

  if (discPct > 0) {
    // Discount active — show strikethrough original + discounted price + savings
    if (origEl) { origEl.textContent = `SGD $${subtotal.toFixed(2)}`; origEl.classList.add('show'); }
    priceEl.textContent = `SGD $${total.toFixed(2)}`;
    saveEl.textContent = `You save SGD $${discAmount.toFixed(2)} (${Math.round(discPct * 100)}% off)`;
    saveEl.classList.add('show');
    saveBar.classList.add('show');
  } else if (addOnCount > 0) {
    // No discount yet — show nudge
    if (origEl) { origEl.textContent = ''; origEl.classList.remove('show'); }
    priceEl.textContent = `SGD $${subtotal.toFixed(2)}`;
    const piecesNeeded = totalCount < 3 ? 3 - totalCount : 5 - totalCount;
    const nextDisc = totalCount < 3 ? '15%' : '20%';
    saveEl.textContent = `Add ${piecesNeeded} more piece${piecesNeeded > 1 ? 's' : ''} to unlock ${nextDisc} off`;
    saveEl.classList.add('show');
    saveBar.classList.add('show');
  } else {
    if (origEl) { origEl.textContent = ''; origEl.classList.remove('show'); }
    priceEl.textContent = `SGD $${subtotal.toFixed(2)}`;
    saveEl.classList.remove('show');
    saveBar.classList.remove('show');
  }
}
function switchTab(id, btn) {
  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
  document.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById('tab-' + id).classList.add('active');
}

/* ── ACCORDIONS ── */
function toggleAcc(id) {
  document.getElementById(id).classList.toggle('open');
}

/* ── YMAL ── */
const YMAL = [
  { name:'Premium Bamboo Long Sleeve Baby Onesie', price:39.90, badge:'Bestseller',
     img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/230512326597_0053_01_RM_1600x1600_07432c31-7885-425c-afb8-c3fb89465441.jpg?v=1769761692',
     url:'https://www.raphandremy.com/products/premium-bamboo-long-sleeve-baby-onesie' },
  { name:'Premium Bamboo Baby Onesie Dress',        price:39.90, badge:null,
     img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/230512326597_0001_01_RM_1600x1600_5261d6ad-4968-4641-adf3-d12fbe1b2399.jpg?v=1769761888',
     url:'https://www.raphandremy.com/products/premium-bamboo-baby-onesie-dress' },
  { name:'Premium Bamboo Sleeveless Baby Onesie',   price:31.90, badge:'New Colours',
     img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/RAPH_REMY_Sleeveless_Onesie_Sky_Blue.jpg?v=1750063683',
     url:'https://www.raphandremy.com/products/premium-bamboo-sleeveless-baby-onesie' },
  { name:'Premium Bamboo Baby Leggings',             price:34.90, badge:null,
     img:'https://cdn.shopify.com/s/files/1/0078/0940/0883/files/230512326597_0044_01_RM_1600x1600_8e2a402b-fb2d-4ae6-ad94-c9dae7e59a8b.jpg?v=1769761669',
     url:'https://www.raphandremy.com/products/premium-bamboo-baby-leggings' },
];

async function apiFetch(url, options = {}) {
  try {
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers // This allows you to override or add new headers
      },
      ...options // Spreads any other options like method: 'POST', body: '...', etc.
    };

    const response = await fetch(url, defaultOptions);

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error(`[apiFetch Error] fetching ${url}:`, error.message);
    throw error; 
  }
}

function productCardItemColorPicker(productId, ci, el) {
  el.closest('.ymal-card-swatches').querySelectorAll('.ymal-card-swatch').forEach((s, j) =>
    s.classList.toggle('active', j === ci)
  );
  const cardImg = document.querySelector(`#product-card-item-${productId} .ymal-img img`);
  if (cardImg) cardImg.src = el?.getAttribute('data-image') + '&width=600';

  // Keep the card's links pointing at the colour the shopper is looking at.
  const swatchUrl = el.getAttribute('data-url');
  if (swatchUrl) {
    document
      .querySelectorAll(`#product-card-item-${productId} .ymal-card-link`)
      .forEach(a => (a.href = swatchUrl));
  }

  const variantSizes = JSON.parse(el.getAttribute('data-size') || '[]');
  const sizeSelect = document.getElementById(`ymal-size-${productId}`);
  if (sizeSelect) {
    sizeSelect.innerHTML = '<option value="" disabled selected>Select a size</option>' +
      variantSizes.map(vs => `<option value="${vs.variantId}" ${!vs.isAvailable ? 'disabled' : ''}>${vs.size}</option>`).join('');
  }

  const atcBtn = document.getElementById(`ymal-add-${productId}`);
  if (atcBtn) {
    atcBtn.disabled = true;
    atcBtn.classList.remove('ready');
  }
}

function productCardItemSizePicker(productId, el) {
  const atcBtn = document.getElementById(`ymal-add-${productId}`);
  const productSelect = document.getElementById(`product-select-${productId}`);
  if (atcBtn && productSelect) {
    atcBtn.disabled = false;
    atcBtn.classList.toggle('ready', !!el.value);
    productSelect.value = el.value;
  }
}

// The YMAL cards are rendered by sections/product-details-section-recommendations
// .liquid (via snippets/ymal-card.liquid) and fetched with Shopify's section_id
// path on the recommendations route. buildProductCardItem() used to build them
// here from /recommendations/products.json, but that endpoint carries no
// metafields, so a colour-grouped product could only show its own per-colour
// title and never its group's sibling colours. Same single request either way.
//
// productCardItemColorPicker() / productCardItemSizePicker() above still drive
// the rendered markup — the section emits the same data-image / data-url /
// data-size attributes they already read.
async function buildRecommendations() {
  const grid = document.getElementById('ymal-grid');
  if (!grid) return;

  const url = grid.getAttribute('data-url');
  if (!url) return;

  const hide = () => document
    .querySelectorAll('.product-details-section-recommendations')
    .forEach(el => (el.style.display = 'none'));

  let html;
  try {
    const res = await fetch(url);
    if (!res.ok) { hide(); return; }
    html = await res.text();
  } catch (e) {
    hide();
    return;
  }

  // The route returns the whole section; take the grid it rendered.
  const doc  = new DOMParser().parseFromString(html, 'text/html');
  const next = doc.getElementById('ymal-grid');
  if (!next || !next.children.length) { hide(); return; }

  grid.innerHTML = next.innerHTML;
}

const ymalSel = {};

function ymalPickColour(pi, ci, el) {
  el.closest('.ymal-card-swatches').querySelectorAll('.ymal-card-swatch').forEach((s, j) =>
    s.classList.toggle('active', j === ci)
  );
  if (!ymalSel[pi]) ymalSel[pi] = {};
  ymalSel[pi].colour = ci;
}

function ymalPickSize(pi, sel) {
  if (!ymalSel[pi]) ymalSel[pi] = {};
  ymalSel[pi].size = sel.value;
  document.getElementById(`ymal-add-${pi}`).classList.toggle('ready', !!sel.value);
}

function ymalConfirmAdd(pi) {
  const btn   = document.getElementById(`ymal-add-${pi}`);
  const szSel = document.getElementById(`ymal-size-${pi}`);
  if (!szSel || !szSel.value) {
    // Highlight the select so user knows what to do
    szSel.style.borderColor = 'var(--red)';
    szSel.style.boxShadow   = '0 0 0 2px rgba(232,64,64,.15)';
    szSel.focus();
    setTimeout(() => { szSel.style.borderColor = ''; szSel.style.boxShadow = ''; }, 1800);
    return;
  }
  const p       = YMAL[pi];
  const size    = szSel.value;
  const colourIdx = ymalSel[pi]?.colour ?? 0;
  const colour  = COLOURS[colourIdx].name;
  addToCart(p.name, colour, size, p.price, p.img);
  btn.textContent = 'Added to Cart';
  btn.classList.add('added');
  setTimeout(() => {
    if (szSel) szSel.value = '';
    btn.textContent = 'Add to Cart';
    btn.classList.remove('added', 'ready');
    delete ymalSel[pi];
  }, 2000);
}

/* ── MORE IN [COLOUR] ── now handled entirely by custom-product.js ── */

/* Also sync More In section when main colour changes */

/* ── STICKY ── */
function initSticky() {
  const hero = document.getElementById('product-top');
  const bar  = document.getElementById('sticky-bar');
  // On touch/mobile: always show sticky bar
  if (window.matchMedia('(max-width: 768px)').matches || window.matchMedia('(hover: none)').matches) {
    bar.classList.add('visible');
    return;
  }
  new IntersectionObserver(([e]) => {
    bar.classList.toggle('visible', !e.isIntersecting);
  }, { rootMargin: '-60px 0px 0px 0px', threshold: 0 }).observe(hero);
}

/* ── REVIEW FILTERS ── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.rev-filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.rev-filters').querySelectorAll('.rev-filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
});

/* Named rrScrollToId, not scrollTo: a global `function scrollTo` overwrites
   window.scrollTo and silently breaks every smooth-scroll call in the theme. */
function rrScrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.pageYOffset - window.rrHeaderOffset();
  window.scrollTo({ top: top, behavior: 'smooth' });
}

/* moreSelectSz / moreAdd removed — colour matching now handled by custom-product.js */
function pairSelectSz(sel, cardId) {
  const btn = document.getElementById(cardId + '-btn');
  if (sel.value) {
    btn.classList.add('ready');
  } else {
    btn.classList.remove('ready');
  }
}
function pairAdd(cardId) {
  const btn = document.getElementById(cardId + '-btn');
  if (!btn.classList.contains('ready')) return;
  const sel = btn.closest('.pair-card').querySelector('.pair-size-select');
  btn.textContent = 'Added';
  btn.classList.add('added');
  btn.classList.remove('ready');
  setTimeout(() => {
    btn.textContent = 'Add';
    btn.classList.remove('added');
    sel.value = '';
  }, 1800);
}

/* ── MOBILE GALLERY SWIPE ── */
(function() {
  let touchStartX = 0;
  let touchStartY = 0;

  function getGalleryUrls() {
    const thumbs = Array.from(document.querySelectorAll('#gallery-thumbs .g-thumb'));
    return thumbs.map(t => {
      const img = t.querySelector('img');
      return img ? img.src.replace(/&width=\d+/, '&width=900') : null;
    }).filter(Boolean);
  }

  function getActiveIndex() {
    const thumbs = Array.from(document.querySelectorAll('#gallery-thumbs .g-thumb'));
    return thumbs.findIndex(t => t.classList.contains('active'));
  }

  function goToIndex(idx) {
    const thumbs = Array.from(document.querySelectorAll('#gallery-thumbs .g-thumb'));
    if (!thumbs.length) return;
    const clamped = Math.max(0, Math.min(idx, thumbs.length - 1));
    const thumb = thumbs[clamped];
    if (thumb) {
      const url = thumb.querySelector('img')?.src.replace(/&width=\d+/, '&width=900') || '';
      selThumb(thumb, url);
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('gallery-main');
    if (!el) return;

    el.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    el.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < 30 || Math.abs(dy) > Math.abs(dx) * 0.8) return; // not a horizontal swipe
      const cur = getActiveIndex();
      goToIndex(dx < 0 ? cur + 1 : cur - 1);
    }, { passive: true });
  });

  /* Expose for dot navigation if needed */
  window.galleryGoTo = goToIndex;
})();



const FREE_SHIP_THRESHOLD = 99; // SGD
const CURRENCY = 'SGD $';

/* ── Cart state ── */
let cartItems = []; // { id, name, colour, colourHex, size, price, qty }
let cartUpsells = [
  { id:'u1', name:'Classic Onesie · Beige',          colour:'Beige',           colourHex:'#C8B8A0', price:34.90, label:'' },
  { id:'u2', name:'Classic Onesie · Dusty Pink',     colour:'Dusty Pink',      colourHex:'#DCA8A8', price:34.90, label:'' },
  { id:'u3', name:'Classic Onesie · Agean Teal',     colour:'Agean Teal',      colourHex:'#4A8C9C', price:34.90, label:'' },
  { id:'u4', name:'Classic Onesie · Army Green',     colour:'Army Green',      colourHex:'#6B7C5A', price:34.90, label:'' },
];
let upsellAdded = new Set();

/* ── Colour → hex map (matches PDP swatches) ── */
const COLOUR_HEX = Object.fromEntries(COLOURS.map(c => [c.name, c.hex]));

/* ── Open / close ── */
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCart();
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}
// ESC key
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

// Swipe down to close (mobile bottom sheet)
(function() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  let startY = 0, isDragging = false;
  drawer.addEventListener('touchstart', e => {
    // Only start drag if scrolled to top of cart-body
    const body = document.getElementById('cart-body');
    if (body && body.scrollTop > 0) return;
    startY = e.touches[0].clientY;
    isDragging = true;
    drawer.style.transition = 'none';
  }, { passive: true });
  drawer.addEventListener('touchmove', e => {
    if (!isDragging) return;
    const delta = e.touches[0].clientY - startY;
    if (delta > 0) {
      drawer.style.transform = 'translateY(' + delta + 'px)';
    }
  }, { passive: true });
  drawer.addEventListener('touchend', e => {
    if (!isDragging) return;
    isDragging = false;
    drawer.style.transition = '';
    const delta = e.changedTouches[0].clientY - startY;
    if (delta > 80) {
      closeCart();
    } else {
      drawer.style.transform = '';
    }
  }, { passive: true });
})();

/* ── Add item (called by handleATC) ── */
function addToCart(name, colour, size, price, img) {
  const hex = COLOUR_HEX[colour] || '#B0ACA8';
  const existing = cartItems.find(i => i.name === name && i.colour === colour && i.size === size);
  if (existing) {
    existing.qty++;
  } else {
    // img: explicit product img > colour swatch img > null
    const colourImg = (COLOURS.find(c => c.name === colour) || {}).img || null;
    cartItems.push({
      id: Date.now() + Math.random(),
      name, colour, colourHex: hex, size, price, img: img || colourImg, qty: 1
    });
  }
  updateBadge();
  renderCart();
  openCart();
}

/* ── Qty stepper ── */
function changeQty(id, delta) {
  const item = cartItems.find(i => i.id === id);
  if (!item) return;
  item.qty += delta;
  if (item.qty <= 0) cartItems = cartItems.filter(i => i.id !== id);
  updateBadge();
  renderCart();
}

/* ── Remove item ── */
function removeItem(id) {
  cartItems = cartItems.filter(i => i.id !== id);
  updateBadge();
  renderCart();
}

/* ── Upsell quick-add ── */
function upsellAdd(uid, btnEl) {
  if (upsellAdded.has(uid)) return;
  upsellAdded.add(uid);
  const u = cartUpsells.find(x => x.id === uid);
  if (u) addToCart(u.name, u.colour, '3–6M', u.price);
  btnEl.textContent = 'Added';
  btnEl.classList.add('added');
}

/* ── Totals ── */
function getSubtotal() {
  return cartItems.reduce((sum, i) => sum + i.price * i.qty, 0);
}
function getTotalQty() {
  return cartItems.reduce((sum, i) => sum + i.qty, 0);
}

/* ── Badge ── */
function updateBadge() {
  const qty = getTotalQty();
  const badge = document.getElementById('cart-badge');
  if (!badge) return;
  if (qty > 0) {
    badge.textContent = qty > 9 ? '9+' : qty;
    badge.style.display = 'flex';
  } else {
    badge.style.display = 'none';
  }
}

/* ── Shipping bar ── */
function renderShipBar() {
  const textEl = document.getElementById('cart-ship-text');
  const fillEl = document.getElementById('cart-ship-fill');
  if (!textEl || !fillEl) return;

  const qty = getTotalQty();

  if (qty === 0) {
    fillEl.style.width = '0%';
    fillEl.style.background = '';
    textEl.className = 'cart-ship-text';
    textEl.innerHTML = 'Add <strong>3 items</strong> to unlock 15% off';
    return;
  }

  if (qty >= 5) {
    // 20% tier unlocked
    fillEl.style.width = '100%';
    fillEl.style.background = 'var(--green)';
    textEl.className = 'cart-ship-text done';
    textEl.innerHTML = '<strong>20% off</strong> applied ✓';
  } else if (qty >= 3) {
    // 15% tier, nudge toward 20%
    const need = 5 - qty;
    const pct  = Math.round((qty / 5) * 100);
    fillEl.style.width = pct + '%';
    fillEl.style.background = 'var(--green)';
    textEl.className = 'cart-ship-text done';
    textEl.innerHTML = `<strong>15% off applied</strong> — add ${need} more item${need === 1 ? '' : 's'} for 20%`;
  } else {
    // Nudge toward 15%
    const need = 3 - qty;
    const pct  = Math.round((qty / 3) * 100);
    fillEl.style.width = pct + '%';
    fillEl.style.background = '';
    textEl.className = 'cart-ship-text';
    textEl.innerHTML = `Add <strong>${need} more item${need === 1 ? '' : 's'}</strong> to unlock 15% off`;
  }
}

/* ── Render item HTML ── */
function renderItemHTML(item) {
  const total = (item.price * item.qty).toFixed(2);
  const bg = item.colourHex || '#ede9e3';
  // Use product-specific img if set, otherwise fall back to colour swatch
  const thumbSrc = item.img ? (item.img.includes('?') ? item.img + '&width=160' : item.img + '?width=160') : '';
  return `
    <div class="cart-item" id="ci-${item.id}">
      <div class="cart-item-img" style="background:${bg}22;">
        ${thumbSrc ? `<img src="${thumbSrc}" alt="${item.name}" style="width:100%;height:100%;object-fit:cover;display:block;">` : `<div style="width:22px;height:22px;border-radius:50%;background:${bg};opacity:.5;"></div>`}
      </div>
      <div class="cart-item-meta">
        <div class="cart-item-name">${item.name}</div>
        <div class="cart-item-variant">${item.colour} &nbsp;·&nbsp; ${item.size}</div>
        <div class="cart-item-actions">
          <div class="cart-qty">
            <button class="cart-qty-btn" onclick="changeQty(${item.id}, -1)" aria-label="Decrease quantity">−</button>
            <span class="cart-qty-num">${item.qty}</span>
            <button class="cart-qty-btn" onclick="changeQty(${item.id}, 1)" aria-label="Increase quantity">+</button>
          </div>
          <button class="cart-item-remove" onclick="removeItem(${item.id})">Remove</button>
        </div>
      </div>
      <div class="cart-item-price">${CURRENCY}${total}</div>
    </div>
  `;
}

/* ── Render upsell cards ── */
function renderUpsells() {
  const nudge = document.getElementById('cart-upsell');
  if (!nudge) return;
  const qty = getTotalQty();
  const titleEl = document.getElementById('cart-bundle-title');
  const subEl   = document.getElementById('cart-bundle-sub');

  if (qty === 0) {
    nudge.classList.remove('show');
    return;
  }

  nudge.style.display = 'flex';

  if (qty >= 6) {
    if (titleEl) titleEl.textContent = '30% bundle discount applied';
    if (subEl)   subEl.textContent   = 'Your 6+ item discount is active at checkout.';
    nudge.style.background   = 'var(--green-light)';
    nudge.style.borderColor  = '#c8e6d2';
    if (titleEl) titleEl.style.color = 'var(--green)';
  } else if (qty >= 4) {
    if (titleEl) titleEl.textContent = '20% bundle discount applied';
    if (subEl)   subEl.textContent   = `Add ${6 - qty} more item${6 - qty === 1 ? '' : 's'} to unlock 30% off.`;
    nudge.style.background   = 'var(--green-light)';
    nudge.style.borderColor  = '#c8e6d2';
    if (titleEl) titleEl.style.color = 'var(--green)';
  } else {
    const need = 4 - qty;
    if (titleEl) titleEl.textContent = `Add ${need} more item${need === 1 ? '' : 's'} to unlock 20% off`;
    if (subEl)   subEl.textContent   = '4 items = 20% off · 6+ items = 30% off';
    nudge.style.background   = 'var(--off-white)';
    nudge.style.borderColor  = '';
    if (titleEl) titleEl.style.color = 'var(--ink)';
  }
}

/* ── Master render ── */
function renderCart() {
  const isEmpty = cartItems.length === 0;
  const emptyEl   = document.getElementById('cart-empty');
  const itemsEl   = document.getElementById('cart-items');
  const upsellEl  = document.getElementById('cart-upsell');
  const footerEl  = document.getElementById('cart-footer');
  const countEl   = document.getElementById('cart-header-count');
  const subEl     = document.getElementById('cart-subtotal-price');

  const qty = getTotalQty();
  if (countEl) countEl.textContent = qty > 0 ? `My Bag (${qty})` : 'My Bag';

  if (isEmpty) {
    emptyEl.style.display  = 'flex';
    itemsEl.style.display  = 'none';
    if (upsellEl) upsellEl.style.display = 'none';
    footerEl.style.display = 'none';
    const pkgElEmpty = document.getElementById('cart-pkg-upsell');
    if (pkgElEmpty) pkgElEmpty.style.display = 'none';
  } else {
    emptyEl.style.display  = 'none';
    itemsEl.style.display  = 'block';
    footerEl.style.display = 'block';
    // Show packaging upsell if not already added
    const pkgEl = document.getElementById('cart-pkg-upsell');
    const pkgAlreadyInCart = cartItems.some(i => i.name === 'DIY Gift Supplies');
    if (pkgEl) pkgEl.style.display = pkgAlreadyInCart ? 'none' : 'flex';
    if (!pkgAlreadyInCart) {
      const pkgBtn = document.getElementById('cart-pkg-btn');
      if (pkgBtn) { pkgBtn.textContent = 'Add'; pkgBtn.classList.remove('added'); }
      packagingAdded = false;
    }
    itemsEl.innerHTML = cartItems.map(renderItemHTML).join('');
    renderSubtotalWithDiscount();
    renderUpsells();
  }

  renderShipBar();
}

/* ── Packaging upsell ── */
let packagingAdded = false;

function addPackaging(btnEl) {
  if (packagingAdded) return;
  packagingAdded = true;
  addToCart('DIY Gift Supplies', 'N/A', 'One Size', 9.90, 'https://www.raphandremy.com/cdn/shop/files/RAPH_REMY_DIY_Gift_Supplies_5a95e0c6-2cd9-4001-9d17-902589c347bf.jpg?v=1707295743');
  btnEl.textContent = 'Added';
  btnEl.classList.add('added');
  // Hide the upsell card after adding
  const card = document.getElementById('cart-pkg-upsell');
  if (card) { card.style.opacity = '.5'; card.style.pointerEvents = 'none'; }
}


/* ── Bundle discount pricing in cart ── */
function renderSubtotalWithDiscount() {
  const subEl   = document.getElementById('cart-subtotal-price');
  const origEl  = document.getElementById('cart-subtotal-orig');
  const saveEl  = document.getElementById('cart-savings-line');
  if (!subEl) return;

  const qty      = getTotalQty();
  const subtotal = getSubtotal();

  let discPct = 0;
  if (qty >= 5)      discPct = 0.20;
  else if (qty >= 3) discPct = 0.15;

  if (discPct > 0) {
    const saving     = subtotal * discPct;
    const discounted = subtotal - saving;

    // Discounted price — black, bold
    subEl.textContent      = CURRENCY + discounted.toFixed(2);
    subEl.style.color      = 'var(--ink)';
    subEl.style.fontWeight = '600';

    // Strikethrough original — grey
    if (origEl) {
      origEl.textContent          = CURRENCY + subtotal.toFixed(2);
      origEl.style.display        = 'inline';
      origEl.style.color          = 'var(--ink-4)';
      origEl.style.textDecoration = 'line-through';
    }

    // Savings line — right-aligned, green, below total row
    if (saveEl) {
      saveEl.textContent   = `You save ${CURRENCY}${saving.toFixed(2)}`;
      saveEl.style.display = 'block';
      saveEl.style.color   = 'var(--green)';
    }

  } else if (qty > 0) {
    subEl.textContent      = CURRENCY + subtotal.toFixed(2);
    subEl.style.color      = '';
    subEl.style.fontWeight = '';
    if (origEl) { origEl.textContent = ''; origEl.style.display = 'none'; }
    // Nudge toward next tier
    if (saveEl) {
      const piecesNeeded = qty < 3 ? 3 - qty : 5 - qty;
      const nextDisc = qty < 3 ? '15%' : '20%';
      if (piecesNeeded > 0) {
        saveEl.textContent   = `Add ${piecesNeeded} more item${piecesNeeded > 1 ? 's' : ''} to unlock ${nextDisc} off`;
        saveEl.style.display = 'block';
        saveEl.style.color   = 'var(--ink-3)';
      } else {
        saveEl.style.display = 'none';
      }
    }
  } else {
    subEl.textContent      = CURRENCY + subtotal.toFixed(2);
    subEl.style.color      = '';
    subEl.style.fontWeight = '';
    if (origEl) { origEl.textContent = ''; origEl.style.display = 'none'; }
    if (saveEl) saveEl.style.display = 'none';
  }
}
/* ── Checkout stub ── */
function handleCheckout() {
  alert('Redirecting to checkout…');
}

/* ═══ OVERRIDE handleATC to wire into cart ═══ */
const _origHandleATC = handleATC;
function handleATC() {
  if (!activeSize) {
    document.getElementById('size-error').classList.add('show');
    document.getElementById('size-btns').scrollIntoView({ behavior:'smooth', block:'center' });
    return;
  }
  if (!activeOOS) {
    // Add to cart state
    const colour = document.getElementById('colour-name').textContent;
    addToCart('Classic Baby Onesie', colour, activeSize, 34.90, (COLOURS.find(c=>c.name===colour)||{}).img);
    // Flash the ATC button
    const btn = document.getElementById('atc-btn');
    const sb  = document.getElementById('sticky-atc-btn');
    btn.textContent = 'Added to Cart';
    btn.classList.add('added');
    sb.textContent = 'Added';
    sb.classList.add('added');
    setTimeout(() => {
      btn.textContent = 'Add to cart';
      btn.classList.remove('added');
      sb.textContent = 'Add to cart';
      sb.classList.remove('added');
    }, 2000);
  } else {
    // Notify flow
    const btn = document.getElementById('atc-btn');
    btn.textContent = "We'll notify you";
    btn.classList.add('added');
    setTimeout(() => {
      btn.textContent = 'Notify Me When Available';
      btn.classList.remove('added');
    }, 2400);
  }
}


function openDrawer(){
  document.getElementById('mobileDrawer').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeDrawer(){
  document.getElementById('mobileDrawer').classList.remove('open');
  document.body.style.overflow='';
}
// Close drawer on Escape key
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawer()});

// Nav scroll shadow
// window.addEventListener('scroll', () => {
//   document.getElementById('nav').classList.toggle('scrolled', window.scrollY > 10);
// }, { passive: true });


function setPersonaliseCTALink() { 
  const currentPath = window.location.pathname;  
  const newDynamicUrl = currentPath + '-personalised';
  const ctaButton = document.querySelector('.personalise-button');
  if (ctaButton) {
      ctaButton.href = newDynamicUrl;
  }
}